import { useState, useEffect } from 'react'
import Section from './_Section'
import { createMarkup } from '../../helpers/markup'
import ButtonEl from '../helpers/ctas/Button'
import Picture from '../helpers/Picture'
import Image from '../helpers/Image'
import TitleBlock from '../helpers/TitleBlock'
import { transformPaddingToTailwind } from '../../helpers/style'
import themeConfig from '../../../theme.config'
import HeroCtaBlock from '../helpers/HeroCtaBlock'

function HeroBanner(props) {
  // const hasCardItems = props.cardItems.length != 0
  const maxCards = 6
  const [hasCardItems, setHasCardItems] = useState(0)
  const [cardColumns, setCardColumns] = useState(6)
  const [textAlignment, setTextAlignment] = useState({
    flex: 'center',
    align: 'center',
  })
  const [cardStartCols, setCardStartCols] = useState('col-start-1')
  const [cardSpanCols, setCardSpanCols] = useState('col-span-4')
  const componentPadding = transformPaddingToTailwind(props.componentPadding, true)

  useEffect(() => {
    setHasCardItems(() => props.cardItems.length != 0)
    setCardColumns(() => {
      let cols = 'full'
      switch (props.cardItems.length) {
        case 6:
        case 5:
          cols = 'justify-between'
          break
        case 4:
        case 3:
        case 2:
          cols = 'justify-evenly'
          break
        case 1:
          cols = 'justify-center'
          break
      }
      return cols
    })
    let start = 'col-start-1'
    let span = 'col-span-4'
    switch (props.cardItems.length) {
      case 6:
        start = 'col-start-1 md-col-start-1'
        span = 'col-span-2 md:col-span-4'
        break
      case 5:
        start = 'col-start-1 md:col-start-1 2xl:col-start-3'
        span =
          'col-span-2 md:col-span-4 2xl:col-span-4 max-md:[&:last-child]:col-start-2 md:max-2xl:[&:nth-last-child(2)]:col-start-3  '
        break
      case 4:
        start = 'col-start-1 md:col-start-1 2xl:col-start-5'
        span = 'col-span-2 md:col-span-4 2xl:col-span-4 md:max-2xl:[&:last-child]:col-start-5 '
        break
      case 3:
        start = 'col-start-1 md-col-start-1 2xl:col-start-7'
        span = 'col-span-2 md:col-span-4 2xl:col-span-4 max-md:[&:last-child]:col-start-2 '
        break
      case 2:
        start = 'col-start-1 md:col-start-3 2xl:col-start-9'
        span = 'col-span-2 md:col-span-4 2xl:col-span-4'
        break
      case 1:
        start = 'col-start-2 md:col-start-5 2xl:col-start-11 '
        span = 'col-span-2 md:col-span-4 2xl:col-span-4'
        break
    }
    setCardStartCols(start)
    setCardSpanCols(span)
  }, [props.cardItems])

  useEffect(() => {
    setTextAlignment((prevState) => {
      const newState = { ...prevState }
      const alignment = props.contentAlignment?.toLowerCase() ?? 'center'
      if (newState.align !== props.contentAlignment?.toLowerCase()) {
        newState.flex = alignment === 'center' ? 'center' : 'start'
        newState.align = alignment === 'center' ? 'center' : 'left'
      }
      return newState
    })
  }, [])

  const pushEngageEvent = (e, props) => {
    umbEngage(
      "send",
      "event",
      "Component interaction",
      "Icon card click",
      props?.title?.toString().trim()
    )
  }

  return (
    <>
      <Section
        {...props}
        type="heroBanner"
        sectionTitle={false}
        mobileBackgroundImage={
          themeConfig.settings.heroForegroundImages ? props.mobileBackgroundImage : props.mobileImage
        }
        desktopBackgroundImage={
          themeConfig.settings.heroForegroundImages ? props.desktopBackgroundImage : props.desktopImage
        }
        innerClass={`flex justify-${textAlignment.flex} ${componentPadding.top} ${hasCardItems ? componentPadding.mid : componentPadding.bottom}`}
      >
        {themeConfig.settings.heroForegroundImages && (
          <div className="px-6">
            <div className={`flex  justify-center items-center gap-8`}>
              <div className={`basis-full ${props.desktopImage ? 'lg:basis-1/2' : ''} shrink-0`}>
                {(props.title || props.description) && <TitleBlock {...props} />}
                {props.mobileImage && <Image {...props.mobileImage} className="mx-auto lg:hidden" />}
                {props.ctaLinkItem.length != 0 && (
                  <HeroCtaBlock {...props} basis="full" textAlignment={textAlignment} />
                )}
              </div>
              {props.desktopImage && (
                <div className="basis-full lg:basis-5/12 shrink-0 max-lg:hidden">
                  <Image {...props.desktopImage} className="mx-auto max-lg:hidden" />
                </div>
              )}
            </div>
          </div>
        )}
        {!themeConfig.settings.heroForegroundImages && (props.title || props.description) && (
          <div className={`mx-6 max-w-3xl text-${textAlignment.align}`}>
            <TitleBlock {...props} />
            {props.ctaLinkItem.length != 0 && <HeroCtaBlock {...props} textAlignment={textAlignment} />}
          </div>
        )}
      </Section>
      {(hasCardItems || props.footnoteText) && (
        <section
          data-index={`${props.idx + 0.5}`}
          className={`${props.backgroundConfiguration === 'Contained' ? 'container mx-auto' : ''}`}
        >
          <div data-type="footnote" className="inner container mx-auto px-7 basis-full">
            {hasCardItems && (
              // <div className={`flex flex-wrap ${cardColumns} mx-auto max-2xl:max-w-3xl ${componentPadding.card}`}>
              <div
                className={`grid  grid-cols-4 md:grid-cols-12 2xl:grid-cols-[repeat(24,_1fr)] gap-4 ${cardColumns} mx-auto max-2xl:max-w-3xl ${componentPadding.card}`}
              >
                {props.cardItems.map((cardItem, i) => {
                  const inner = (
                    <>
                      <div
                        className={`aspect-square break-word flex flex-col justify-center bg-white px-4 py-6 transition-all duration-300 rounded-lg  ${cardItem.titleAlignment === 'Center' ? 'text-center' : 'text-left'}`}
                      >
                        <div className="max-w-[50%] mb-7 mx-auto">
                          <Picture
                            desktopImage={cardItem.desktopImage}
                            mobileImage={cardItem.mobileImage}
                            className={`mx-auto`}
                          />
                        </div>
                        {cardItem.title}
                      </div>
                    </>
                  )
                  // const className = ` w-full px-2 max-sm:py-1 py-2 cardItem  basis-1/2 md:max-2xl:basis-1/3 2xl:basis-1/6`
                  const className = `${i === 0 ? cardStartCols : ''} w-full max-sm:py-1 py-2 cardItem  basis-1/2 md:max-2xl:basis-1/3 2xl:basis-1/6 rounded-lg ${cardSpanCols} `
                  return cardItem.ctaLinkItem[0]?.link?.url ? (
                    <a
                      href={cardItem.ctaLinkItem[0].link.url}
                      target={cardItem.ctaLinkItem[0].link.target}
                      key={i}
                      onClick={(e) => {pushEngageEvent(e, cardItem)}}
                      className={`${className} hover:scale-[1.05] transition-all duration-300 shadow-2xl shadow-${themeConfig.settings.hero.card.shadow.base} ${cardItem.ctaLinkItem[0] && cardItem.ctaLinkItem[0].link?.url ? `hover:shadow-${themeConfig.settings.hero.card.shadow.hover}/50` : ''}`}
                    >
                      {inner}
                    </a>
                  ) : (
                    <div
                      key={i}
                      className={`${className} shadow-2xl shadow-${themeConfig.settings.hero.card.shadow.base}`}
                    >
                      {inner}
                    </div>
                  )
                })}
              </div>
            )}

            {props.footnoteText && (
              <div
                className={`${componentPadding.bottom} ${componentPadding.top} text-${textAlignment.align}`}
                data-rte="true"
                dangerouslySetInnerHTML={createMarkup(props.footnoteText)}
              />
            )}
          </div>
        </section>
      )}
    </>
  )
}

export default HeroBanner
